// @flow

export type MainComponentSet = {
  type: 'SET_MAIN_COMPONENT',
  payload: { name: ?string },
};

export function mainComponentSet(name: ?string): MainComponentSet {
  return {
    type: 'SET_MAIN_COMPONENT',
    payload: { name },
  };
}

export type MainComponentInitSet = {
  type: 'SET_INIT_MAIN_COMPONENT',
  payload: { name: ?string },
};

export function mainComponentInitSet(name: ?string): MainComponentInitSet {
  return {
    type: 'SET_INIT_MAIN_COMPONENT',
    payload: { name },
  };
}

export type LocationToErrorMapEntrySet = {
  type: 'SET_LOCATION_TO_ERROR_MAP_ENTRY',
  payload: {
    pathname: string,
    renderError: Object,
  },
};

export function locationToErrorMapEntrySet(
  pathname: string,
  renderError: Object,
): LocationToErrorMapEntrySet {
  return {
    type: 'SET_LOCATION_TO_ERROR_MAP_ENTRY',
    payload: { pathname, renderError },
  };
}

export type LocationToErrorMapEntryUnset = {
  type: 'UNSET_LOCATION_TO_ERROR_MAP_ENTRY',
  payload: { pathname: string },
};

export function locationToErrorMapEntryUnset(pathname: string): LocationToErrorMapEntryUnset {
  return {
    type: 'UNSET_LOCATION_TO_ERROR_MAP_ENTRY',
    payload: { pathname },
  };
}

export type UpwtActionNameSet = {
  type: 'SET_UPWT_ACTION_NAME',
  payload: { name: ?number },
};

export function upwtActionNameSet(name: ?number): UpwtActionNameSet {
  return {
    type: 'SET_UPWT_ACTION_NAME',
    payload: { name },
  };
}
